import Utils from "../../services/Utils.js";

export function getAccountBalanceTemplate(account_balance, role) {
  return `
        <div class="accountBalanceRow grid grid-cols-5 w-full text-white ${
          role != "User" && account_balance.type.toLowerCase() == "sport"
            ? ""
            : "fiveColumnsHolder"
        }">
            ${
              role != "User"
                ? `<span class="text-center text-[14px] font-bold">${account_balance.username}</span>`
                : `<span class="text-center text-[14px] font-bold">*</span>`
            }
            <span  class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.stake
            )}</span>
            <span  class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.win
            )}</span>
            <span  class="text-center text-[14px] font-bold">${
              account_balance.type.toLowerCase() == "casino"
                ? Utils.formatNumber(account_balance.jackpot)
                : "-"
            }</span>
            ${
              role != "User" && account_balance.type.toLowerCase() == "sport"
                ? `<span  class="text-center text-[14px] font-bold">${Utils.formatNumber(
                    account_balance.percentage
                  )}</span>`
                : ""
            }
            ${
              role != "User"
                ? `<span  class="text-center text-[14px] font-bold">${Utils.formatNumber(
                    account_balance.difference
                  )}</span>`
                : ""
            }
            ${
              role == "User"
                ? `<span  class="text-center text-[14px] font-bold">${Utils.formatNumber(
                    account_balance.difference
                  )}</span>`
                : ""
            }
        </div>
    `;
}

export function getSmFinanceTemplate(account_balance) {
  return `
        <div class="accountBalanceRow w-full grid grid-cols-5 text-white  bg-gradient-to-t from-[#232323] to-[#494949] ">
            <span class="text-center text-[14px] font-bold">${
              account_balance.username
            }</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.dif_sport
            )}</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.dif_sport_mng
            )}</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.dif_casino
            )}</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.dif_livecasino
            )}</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.dif_virtual
            )}</span>
            <span class="text-center text-[14px] font-bold">${Utils.formatNumber(
              account_balance.difference
            )}</span>
        </div>
    `;
}
